import React, { FC, ReactElement, useState } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import i18next from 'i18next';
import { useAuthFetchFromRestAPI } from '../../../util/api';
import { ITherapy } from '../../../util/types';
import { emitNotification } from '../../../components/Notification';
import SecondaryButton from '../../../components/SecondaryButton';

type ResendActivationBannerProps = {
  therapy: ITherapy;
};

const ResendActivationBanner: FC<ResendActivationBannerProps> = ({
  therapy,
}: ResendActivationBannerProps): ReactElement | null => {
  const { authFetch } = useAuthFetchFromRestAPI();

  const [resending, setResending] = useState(false);

  if (therapy.patient?.isEmailVerified) {
    return null;
  }

  const resendActivationEmail = async (): Promise<void> => {
    if (!therapy.patient?.accountId) {
      return;
    }

    try {
      setResending(true);

      await authFetch('/api/v1/patients/resend-email/', {
        method: 'POST',
        body: {
          accountId: therapy.patient.accountId,
        },
      });

      emitNotification(
        i18next.t('therapyDetails.resendActivationEmail.successMsg', { email: therapy.patient.email })
      );
    } catch {
      emitNotification(i18next.t('therapyDetails.resendActivationEmail.errorMsg'));
    } finally {
      setResending(false);
    }
  };

  return (
    <Alert
      variant="warning"
      className="d-flex justify-content-center align-items-center text-center border-0 rounded-0 mb-0"
    >
      <Row className="w-100">
        <Col md={12} xs={12} className="d-flex flex-wrap justify-content-center align-items-center gap-3">
          <span>
            <Trans
              i18nKey="therapyDetails.resendActivationEmail.body"
              values={{ email: therapy.patient?.email }}
            />
          </span>

          <SecondaryButton onClick={resendActivationEmail} disabled={resending}>
            {resending ? i18next.t('generic.loading') : i18next.t('therapyDetails.resendActivationEmail.button')}
          </SecondaryButton>
        </Col>
      </Row>
    </Alert>
  );
};

export default ResendActivationBanner;
